import { TextField } from '@mui/material';
import { SyntheticEvent, useCallback, useContext, useEffect, useState } from 'react';

import CharacterLimitHelperText from '@/components/common/CharacterLimitHelperText';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function SchoolDistrictNameInput() {
  const [schoolDistrictName, setSchoolDistrictName] = useState<string | null>(null);
  const { partnerGroupInfo, intakeLabels, updatePartnerGroupInfo, showErrors } =
    useContext(PartnerIntakeContext);

  const handleSchoolDistrictNameChange = useCallback(
    (e: SyntheticEvent) => {
      const updatedValue = (e.target as HTMLInputElement).value;

      setSchoolDistrictName(partnerGroupInfo?.partnerName ?? null);

      const updatedPartnerGroup = {
        ...partnerGroupInfo,
        partnerName: updatedValue,
      };

      if (updatePartnerGroupInfo && partnerGroupInfo) {
        updatePartnerGroupInfo(updatedPartnerGroup);
      }
    },
    [updatePartnerGroupInfo, partnerGroupInfo]
  );

  useEffect(() => {
    if (partnerGroupInfo?.partnerName != schoolDistrictName)
      setSchoolDistrictName(partnerGroupInfo?.partnerName ?? null);
  }, [partnerGroupInfo?.partnerName, schoolDistrictName]);

  return (
    <>
      <TextField
        variant='outlined'
        sx={{ flexGrow: 1 }}
        onChange={handleSchoolDistrictNameChange}
        value={schoolDistrictName ? schoolDistrictName : ''}
        label={intakeLabels.schoolDistrict ?? 'School District'}
        id={'schoolDistrictName'}
        required
        error={
          showErrors &&
          (!partnerGroupInfo?.partnerName ||
            (schoolDistrictName != null && schoolDistrictName?.length >= 1000))
        }
      />
      {schoolDistrictName && schoolDistrictName.length >= 1000 && (
        <CharacterLimitHelperText limit={1000} />
      )}
    </>
  );
}

export default SchoolDistrictNameInput;
